module.exports = __webpack_public_path__ + "static/media/wellbeing.eeb8aa5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/wellbeing.svg
// module id = 191
// module chunks = 5